export default function match() {
    const matchBroadcast = document.querySelector('.js-match-broadcast');
    const matchBroadcastTimer = document.querySelector('.js-match-broadcast-timer');

    if (matchBroadcast && matchBroadcastTimer) {

        const startDateStr = matchBroadcast.dataset.start;
        const [day, month, year, hour, minute] = startDateStr.split('.');
        const startDate = new Date(`${year}-${month}-${day}T${hour}:${minute}:00+03:00`);
        
        function updateTimer() {
            const now = new Date();
            const diff = startDate - now;
            
            if (diff <= 0) {
                matchBroadcastTimer.textContent = 'Трансляция началась';
                matchBroadcast.classList.remove('match-broadcast__box_blocked');
                return;
            }
            
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);
            
            if ( matchBroadcastTimer.classList.contains('js-countdown') ) {
                matchBroadcastTimer.textContent = `${days}д ${hours}ч ${minutes}мин ${seconds}сек`;
            } else {
                matchBroadcastTimer.textContent = `До начала ${days}д ${hours}ч ${minutes}мин ${seconds}сек`;
            }

        }
        
        updateTimer();
        const timerInterval = setInterval(updateTimer, 1000);
        
        return () => clearInterval(timerInterval);


    }
}